module.exports = __webpack_public_path__ + "img/ico-bono.3c65025a.svg";